// 壳启动时的认证引导：挂载后调用一次 /auth/session，
// 并据此初始化 sessionStore。它独立于路由运行，因此无论
// `/login` 还是受保护的壳页面，都能观察到同一份 store 状态。
import { useEffect } from 'react';
import { readSession } from './api';
import { useSessionStore } from '../store/sessionStore';

export function useAuthBootstrap(): void {
  const setAuthenticated = useSessionStore((s) => s.setAuthenticated);
  const setAnonymous = useSessionStore((s) => s.setAnonymous);
  const setBootstrapError = useSessionStore((s) => s.setBootstrapError);

  useEffect(() => {
    let cancelled = false;
    readSession()
      .then((body) => {
        if (cancelled) return;
        if (body) {
          setAuthenticated(body.user, body.csrf_token);
        } else {
          setAnonymous();
        }
      })
      .catch(() => {
        if (cancelled) return;
        setBootstrapError('无法验证当前会话，请检查服务是否可用后重试');
      });
    return () => {
      cancelled = true;
    };
  }, [setAuthenticated, setAnonymous, setBootstrapError]);
}
